import api from "./api";

const apiErrorMessage = (error, fallback) =>
  error.response?.data?.message || fallback;

export const createProject = async (projectData) => {
  try {
    const response = await api.post("/projects", projectData);
    return {
      success: true,
      data: response.data,
      message: "Project created successfully!",
    };
  } catch (error) {
    return {
      success: false,
      error: apiErrorMessage(error, "Failed to create project"),
      status: error.response?.status,
    };
  }
};

export const getAllProjects = async () => {
  try {
    const response = await api.get("/projects");
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: apiErrorMessage(error, "Failed to fetch projects"),
    };
  }
};

export const updateProject = async (projectId, projectData) => {
  try {
    const response = await api.put(`/projects/${projectId}`, projectData);
    return {
      success: true,
      data: response.data,
      message: "Project updated successfully!",
    };
  } catch (error) {
    return {
      success: false,
      error: apiErrorMessage(error, "Failed to update project"),
    };
  }
};

export const deleteProject = async (projectId) => {
  try {
    await api.delete(`/projects/${projectId}`);
    return {
      success: true,
      message: "Project deleted successfully!",
    };
  } catch (error) {
    return {
      success: false,
      error: apiErrorMessage(error, "Failed to delete project"),
    };
  }
};

export const uploadProjectImage = async (
  imageFile,
  websiteName,
  imageType = "main"
) => {
  try {
    const formData = new FormData();
    formData.append("projectImage", imageFile);
    formData.append("websiteName", websiteName || "project");
    formData.append("imageType", imageType);

    const response = await api.post("/projects/upload-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      (error.response?.status === 404
        ? "Upload route not found. Please check server configuration."
        : "Failed to upload project image");
    throw new Error(message);
  }
};

export const toggleDisableProject = async (projectId) => {
  try {
    const response = await api.patch(`/projects/${projectId}/toggle-disable`);
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || "Project status updated successfully",
    };
  } catch (error) {
    return {
      success: false,
      error: apiErrorMessage(error, "Failed to toggle project status"),
    };
  }
};
